<template lang="pug">
  router-view
</template>

<script>
export default {
  // Проверка доступа к разделу
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const user = vm.$store.getters.user;

      if (!user.isAdmin) {
        return vm.$router.replace({ name: 'home' });
      }
    });
  },

  created() {
    this.$store.dispatch('loadUserGroups');
  },
};
</script>
